import { TEpic } from 'Redux/Config';
import Actions from 'Redux/Actions';
import { ofType } from 'redux-observable';
import { catchError, mergeMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { logError } from 'utils/logError';
import { SetupIntent, StripeError } from '@stripe/stripe-js';

export const confirmPaymentMethodRequestEpic: TEpic = (action$) =>
  action$.pipe(
    ofType(Actions.confirmPaymentMethodRequest.type),
    mergeMap((action) =>
      from(action.payload.confirmPayment as Promise<{ setupIntent: SetupIntent; error?: undefined | StripeError }>).pipe(
        mergeMap((response) => {
          if (response.error) {
            if (response.error.code === 'setup_intent_unexpected_state' && response.error.setup_intent) {
              return of(Actions.confirmPaymentMethodSuccess({ setupIntent: response.error.setup_intent }));
            }

            logError(new Error(response.error.message));
            return of(Actions.confirmPaymentMethodFailure({ error: response.error }));
          }
          return of(Actions.confirmPaymentMethodSuccess(response));
        }),
        catchError((error) => {
          if (error?.error.code === 'setup_intent_unexpected_state') {
            return of(Actions.confirmPaymentMethodSuccess({ setupIntent: error.error.setup_intent }));
          }

          logError(error);
          return of(Actions.confirmPaymentMethodFailure({ error }));
        }),
      ),
    ),
  );
